import { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { Prompt } from 'react-router-dom';
import moment from 'moment';
import { SettingsMenuItemsIds } from '../../../../../enums/navigationMenuItemsIds';
import Header, { headerItemsLabels } from '../../../../Common/Header/header';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import Overlay from 'infrastructure/js/components/Overlay/overlay';
import TextAreaField from 'infrastructure/js/components/controls/TextAreaField/textAreaField';

import './aiAgentPreferencesView.scss';

class AiAgentPreferencesView extends Component {
  constructor(props) {
    super(props);

    this.labels = createLabelHelper('mat.administration.settings.aiAgentPreferences.view.');
    this.navigationLabels = createLabelHelper('mat.navigation.confirmation.');
  }

  componentDidMount() {
    this.props.actions.init().then(this.initForm);

    this.props.actions.settingsPageActions.onSelectedMenuItemChanged(SettingsMenuItemsIds.NAV_ELEMENT_AI_AGENT_PREFERENCES);
  }

  initForm = (data) => {

    if (data?.startOfDay?.value) {
      data.startOfDay.value = moment(data.startOfDay.value.trim(), 'HH:mm');
    }

    this.props.initialize({ ...data, });
  };


  renderLoadingOverlay = () => {
    if (!this.props?.sData?.get('loading')) {
      return null;
    }
    return <Overlay.Loading />;
  };

  renderPrompt = () => {
    return <Prompt when={this.props?.isDirty} message={() => this.navigationLabels.get('datanotsaved.text')} />;
  };

  getHeaderItems = () => {
    return {
      title: this.labels.get('title'),
      buttons: [
        {
          id: 'save',
          label: headerItemsLabels.SAVE,
          className: 'no-icon',
          disabled: this.props.pristine,
          action: this.props.handleSubmit(this.onSubmit),
        },
      ],
    };
  };

  onSubmit = (data) => {
    const newData = {
        settings: [
          {
            key: 'generalsetting.orgpreferences.aiagent.memory',
            value: data?.memory.value,
          },
        ],
    };

    this.props.actions.submit(newData).then(this.initForm);
  };



  render() {
    let headerItems = this.getHeaderItems();

    return (
      <div className="ai-agent-preferences-view">
        <Header {...headerItems} />

        <div className="ai-agent-preferences-container">
          <div className="memory-section">
            <div className="preferences-header">
              <label className="preferences-title">{this.labels.get('memory.title')}</label>
            </div>
            <div className="preferences-input">
              {/*<label htmlFor="memory">{this.labels.get('memory.title')}</label>*/}
              <TextAreaField className="memory-textArea" id="sectionRowHorizon"
                             name="memory.value"
                        />
            </div>
          </div>
        </div>

        {this.renderLoadingOverlay()}
        {this.renderPrompt()}
      </div>
    );
  }
}

AiAgentPreferencesView.propTypes = {
  actions: PropTypes.object,
  sData: PropTypes.object,
  handleSubmit: PropTypes.func,
  initialize: PropTypes.func,
  isDirty: PropTypes.bool,
  pristine: PropTypes.bool,
};

AiAgentPreferencesView.defaultProps = {
  actions: {},
  sData: {},
  handleSubmit: () => console.error('Missing handleSubmit function!'),
  initialize: () => console.error('Missing initialize function!'),
  isDirty: false,
  pristine: false,
};

export default reduxForm({
  form: 'aiAgentPreferencesView',
})(AiAgentPreferencesView);
